import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Field, { FieldType } from '../../../elements/Field';
import { T } from 'helpers/i18n';
import cxs from 'cxs/component';
var StretchSetting = function (props) {
    var _a = React.useState(SecctionSelected.General), sectionSelected = _a[0], setSectionSelected = _a[1];
    var values = props.values, options = props.options, onChange = props.onChange;
    console.log('values[\'type\']: ', values['type']);
    var taxesOptions = options['taxesOptions'];
    var operationsOptions = options['operationLinesOptions'];
    var receiptLayoutsOptions = options['receiptLayoutsOptions'];
    var headboardsOptions = options['headboardsOptions'];
    var horasIdaOptions = options['horasIdaOptions'];
    var typeOptions = [
        { name: 'Normal', value: 'normal', selected: !values['type'] || values['type'] === 'normal' },
        { name: T('event'), value: 'event', selected: values['type'] === 'event' },
        { name: 'Transfer', value: 'transfer', selected: values['type'] === 'transfer' }
    ];
    return (React.createElement(Wrapper, null,
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Field, { field: {
                            name: 'type',
                            type: FieldType.ToggleSelect,
                            size: 12,
                            value: values['type'],
                            options: typeOptions,
                        }, onChange: onChange }))),
            values['type'] === 'event' && React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Field, { field: {
                            name: 'dateEvent',
                            type: FieldType.Date,
                            size: 12,
                            mode: 'dp-below',
                            value: values['dateEvent'],
                            options: typeOptions
                        }, onChange: onChange }))))));
};
var Wrapper = cxs('div')({
// paddingBottom: Theme.size.bar,
/*[mediaQueries.desktop]: {
  display: 'flex',
  flexWrap: 'wrap',
  // paddingBottom: 0,
  // marginTop: Theme.common.size.bar / 2 + 'px',
  overflow: 'auto'
} as CSSProperties*/
});
var SecctionSelected;
(function (SecctionSelected) {
    SecctionSelected["General"] = "General";
    SecctionSelected["Type"] = "Type";
})(SecctionSelected || (SecctionSelected = {}));
export default StretchSetting;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/Setting.tsx
// module id = 1546
// module chunks = 0